import { Expose, Type } from 'class-transformer';
import { Model } from '@shared/models/model';
import { Tracking } from "./tracking-driver.model";
import { TruckHasShipment } from "../../fleets/models/truck-has-shipment.model";
import { AvlDevicePosition } from "./avl-device-position,model";
import { AvlShipmentStop } from "./avl-shipment-stop.model";
import { AvlOverSpeed } from "./avl-over-speed.model";
import { G2gLocation } from '../../shipments/models/g2g-location.model';

export class AvlReplay extends Model {
  @Type(() => Tracking)
  @Expose() current: Tracking;

  @Type(() => TruckHasShipment)
  @Expose() truck: TruckHasShipment;

  @Type(() => AvlDevicePosition)
  @Expose() ignitions: (AvlDevicePosition&{ignition?: boolean})[];

  @Type(() => AvlDevicePosition)
  @Expose() brakes: AvlDevicePosition[];

  @Expose() stopDurations: string;
  @Expose() stopsCount: number;

  @Type(() => AvlShipmentStop)
  @Expose() stops: AvlShipmentStop[];

  @Expose() overSpeedCount: number;

  @Type(() => AvlOverSpeed)
  @Expose() overSpeed: AvlOverSpeed[];

  @Type(() => G2gLocation)
  @Expose() gateToGate: G2gLocation[];

  @Expose() showIgnitions: boolean;
  @Expose() showBrakes: boolean;
  @Expose() showStops: boolean;
  @Expose() showOverSpeed: boolean;
  @Expose() showGateToGate: boolean;
}
